module.exports = require("./bas.js");